import { NetworkAccountAvatarProps } from '#/interfaces/NetworkAccountAvatarProps';
import matchSwitch, { _ } from 'match-switch';
import { useMemo } from 'react';
import EthereumAccountAvatar from './EthereumAccountAvatar';
import JdenticonAccountAvatar from './JdenticonAccountAvatar';
import PolkadotAccountAvatar from './PolkadotAccountAvatar';

interface Props extends NetworkAccountAvatarProps {
  symbol?: string;
}

export default function NetworkAccountAvatar({
  symbol,
  address,
  diameter,
  ...props
}: Props) {
  return useMemo(
    () =>
      matchSwitch(symbol, {
        DOT: (
          <PolkadotAccountAvatar
            {...props}
            address={address}
            diameter={diameter}
          />
        ),
        ETH: (
          <EthereumAccountAvatar
            {...props}
            address={address}
            diameter={diameter}
          />
        ),
        KSM: (
          <PolkadotAccountAvatar
            {...props}
            address={address}
            diameter={diameter}
          />
        ),
        // SOL: <JdenticonAccountAvatar {...props} address={address} diameter={diameter}/>,
        XPRT: (
          <JdenticonAccountAvatar
            {...props}
            address={address?.replace(/^persistence/, '')}
            diameter={diameter}
          />
        ),
        UMEE: (
          <JdenticonAccountAvatar
            {...props}
            address={address?.replace(/^umee/, '')}
            diameter={diameter}
          />
        ),
        [_]: (
          <JdenticonAccountAvatar
            {...props}
            address={address}
            diameter={diameter}
          />
        ),
      }),
    [symbol, address, diameter]
  );
}
